import {http} from '../../lib/http'

const state = {
    domainId: null,
    domain: { domain: '', records: [] },
    records: [],
    newRecord: {}
}

const mutations = {
    setDomainId(state, value) {
        state.domainId = value
    },
    setDomain(state, value) {
        state.domain = value
    }

}

const actions = {
    setDomain({dispatch, commit}, domainId) {
        commit('setDomainId', domainId);
        dispatch('loadDomain')
    },
    loadDomain({state, commit}) {
        return http.get('/api/domains/' + state.domainId + '?records=1').then(data => {
            commit('setDomain', data)
        })
    },
    saveRecord({dispatch}, record) {
        return http.post('/api/records/' + record.id+'/save', record).then(() => {
            dispatch('loadDomain')
        })
    },
    deleteRecord({dispatch}, record) {
        return http.post('/api/records/' + record.id + '/delete').then(() => {
            dispatch('loadDomain')
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}




// WEBPACK FOOTER //
// ./src/store/modules/domain.js